'use client'
import React, {forwardRef} from 'react'
import {Button} from '@heroui/react'
import clsx from 'clsx'
import {ButtonProps} from '@heroui/react'

const ButtonWrapper = forwardRef<HTMLButtonElement, ButtonProps>(
  ({...props}, ref) => (
    <Button
      {...props}
      ref={ref}
      className={clsx(
        'bg-transparent p-0 min-w-0 transform-none',
        props.className
      )}
      disableRipple
      disableAnimation>
      {props.children}
    </Button>
  )
)

ButtonWrapper.displayName = 'ButtonWrapper'

export default ButtonWrapper
